import React, { useContext, useState } from "react";
import "./Security_Settings.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import Change_Trading_Password_Modal from "../../../common_components/common_modal/change_trading_password_modal/Change_Trading_Password_Modal";
import { Context } from "../../../../utils/context";

const Security_Settings = () => {
  const [showModal, setShowModal] = useState(false);

  const { IMG_URL, userdata } = useContext(Context);

  // Mask password for display (security best practice)
  const maskedPassword = userdata?.show_password
    ? "••••••••••••"
    : "Not Set";

  return (
    <section className="security-settings-page max-md:!p-0">
      <div className="security-card p-4 max-md:!p-0">
        <div className="card-header ">
          <h2 className="card-title">Security & Authorization</h2>
          {/* <button
            className="edit-action-btn"
            onClick={() => setShowModal(true)}
            aria-label="Edit Security Settings"
          >
            <FontAwesomeIcon icon={faPencil} />
            <span>Edit</span>
          </button> */}
        </div>

        <div className="card-body max-md:!p-0">
          <div className="info-grid ">
            {/* Login Email */}
            <div className="info-row">
              <label className="info-label">Login Email</label>
              <div className="info-value-wrapper">
                <p className="info-value">{userdata?.email || "Not Set"}</p>
              </div>
            </div>

            {/* Trading Password */}
            <div className="info-row">
              <label className="info-label">Trading Password</label>
              <div className="info-value-wrapper password-row">
                <p className="info-value password-masked">{maskedPassword}</p>
                <button
                  className="change-password-btn"
                  onClick={() => setShowModal(true)}
                >
                  Change Password
                </button>
              </div>
            </div>
          </div>

          {/* Security hint */}
          <div className="security-hint">
            <p>
              For your security, passwords are never shown in plain text. 
              Use a strong, unique password and change it regularly.
            </p>
          </div>
        </div>
      </div>

      <Change_Trading_Password_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </section>
  );
};

export default Security_Settings;